import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PAGE_SIZE = 20;

export default function PaginatedDailySummaryTable({
  dailySummary = [] as any,
  formatDateToDayMonthShort = (dateStr: string) => dateStr,
}) {
  const [visibleRows, setVisibleRows] = useState(PAGE_SIZE);

  // Paginate data
  const dataToShow = dailySummary?.slice(0, visibleRows) || [];

  // Check if there are more items to load
  const hasMore = dailySummary?.length > visibleRows;

  const handleLoadMore = () => {
    setVisibleRows((prev) => prev + PAGE_SIZE);
  };
  const { t } = useTranslation();
  return (
    <>
      <table className="_table_11ccc_13 _dailySummaryTable_v5c2k_3">
        <thead>
          <tr>
            <th colSpan={1} style={{ width: 150, minWidth: 20, maxWidth: Number.MAX_VALUE }}>
              <div className="select-none text-headings-headline text-content-tertiary" data-sentry-component="HeaderWrapper" data-sentry-source-file="Table.tsx">{t('Date')}</div>
            </th>
            <th colSpan={1} style={{ width: '150px', minWidth: 20, maxWidth: 9.0072e15 }}>
              <div className="select-none text-headings-headline text-content-tertiary" data-sentry-component="HeaderWrapper" data-sentry-source-file="Table.tsx">{t('Trades')}</div>
            </th>
            <th colSpan={1} style={{ width: '150px', minWidth: '20px', maxWidth: '9.0072e15px' }}>
              <div className="select-none text-headings-headline text-content-tertiary" data-sentry-component="HeaderWrapper" data-sentry-source-file="Table.tsx">{t('Lots')}</div>
            </th>
            <th colSpan={1} style={{ width: '150px', minWidth: '20px', maxWidth: '9.0072e15px' }}>
              <div className="select-none text-headings-headline text-content-tertiary" data-sentry-component="HeaderWrapper" data-sentry-source-file="Table.tsx"><div className="text-right">{t('ResultsText')}</div></div>
            </th>
          </tr>
        </thead>
        <tbody>
          {dataToShow.map((item: any, index: any) => (
            <tr key={index} className="">
              <td style={{ width: 150, minWidth: 20, maxWidth: Number.MAX_VALUE }}>
                <div className="w-[100px] text-content-active">
                  <span data-sentry-component="DateWithPlatformOffset" data-sentry-source-file="DateWithPlatformOffset.tsx">
                    {formatDateToDayMonthShort(item.date)}
                  </span>
                </div>
              </td>
              <td style={{ width: '150px', minWidth: '20px', maxWidth: 9.0072e15 }}>
                <div className="text-labels-medium text-content-primary">
                  {Number(item.trades).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
              </td>
              <td style={{ width: '150px', minWidth: '20px', maxWidth: 9.0072e15 }}>
                <div className="text-labels-medium text-content-primary">
                  {Number(item.lots).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
              </td>
              <td style={{ width: '150px', minWidth: 20, maxWidth: 9.0072e15 }}>
                <div className={`text-right text-labels-medium font-semibold ${Number(item.result) < 0 ? 'text-functional-danger' : 'text-functional-success'}`}>
                  <span>
                    {Number(item.result) < 0 && '-'}${Number(item.result) < 0
                      ? (Number(item.result) * -1).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      : Number(item.result).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* Load More Button */}
      {hasMore && (
        <div className='hide-mod' style={{ textAlign: 'center', margin: '16px 0' }}>
          <button type="button" className="btn btn-secondary" onClick={handleLoadMore}>
            {t('Loadmore')}
          </button>
        </div>
      )}
    </>
  );
}